'use client';

import { confirmModalAtom } from '@/atom/modal';
import { useAtom, useAtomValue } from 'jotai';
import { usePathname, useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';

export default function ConfirmModal() {
  const router = useRouter();
  const pathname = usePathname();
  const [confirmModal, setConfirmModal] = useAtom(confirmModalAtom);

  const [visible, setVisible] = useState(false);
  const [fadeType, setFadeType] = useState<'in' | 'out'>('in');

  useEffect(() => {
    if (!confirmModal.visible) {
      setFadeType('out');
      setTimeout(() => {
        setVisible(false);
      }, 200);
    } else {
      setVisible(true);
      setFadeType('in');
      const isNotHidden = document.body.style.overflowY !== 'hidden';
      if (isNotHidden) {
        document.body.style.overflowY = 'hidden';
      }

      return () => {
        if (isNotHidden) document.body.style.overflowY = 'auto';
      };
    }
  }, [confirmModal.visible]);

  // useEffect(() => {
  //   setConfirmModal({ visible: false });
  // }, [pathname]);

  if (!visible) {
    return null;
  }

  return (
    <div
      className={`fixed w-full max-w-480pxr top-0 z-[100] h-dvh overflow-hidden bg-custom-black/60 flex items-center justify-center ${
        fadeType === 'in' ? 'animate-[fadeIn_300ms_ease-in-out]' : 'animate-[fadeOut_200ms_ease-in-out]'
      }`}
      onClick={() => {
        confirmModal.onOuterClick?.();
      }}
    >
      {confirmModal.visible && (
        <div className='bg-white rounded-12pxr min-w-260pxr max-w-400pxr' onClick={(e) => e.stopPropagation()}>
          <div className='px-24pxr py-28pxr flex flex-col gap-8pxr'>
            {confirmModal.title && (
              <h2 className='text-gray-900 body-16-md text-center whitespace-pre-line'>{confirmModal.title}</h2>
            )}
            {confirmModal.message && (
              <p className='text-gray-700 body-14-regular text-center whitespace-pre-line'>{confirmModal.message}</p>
            )}
            {confirmModal.subMessage && (
              <p className='text-gray-700 body-12-regular text-center whitespace-pre-line'>{confirmModal.subMessage}</p>
            )}
          </div>
          <div className='flex flex-row w-full'>
            <button
              className='w-full border-t border-gray-300 h-50pxr flex items-center justify-center body-16-md text-gray-700'
              onClick={() => {
                confirmModal.onClose?.();
              }}
            >
              {confirmModal.closeButtonText || '취소'}
            </button>
            <button
              className='w-full border-t border-gray-300 h-50pxr flex items-center justify-center body-16-md text-point-500 border-l'
              onClick={() => {
                confirmModal.onConfirm?.();
              }}
            >
              {confirmModal.confirmButtonText || '확인'}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
